module.exports = __webpack_public_path__ + "img/illustration-section-02.e566387a.svg";